import { FixDataPage } from '../../components/FixDataPage';
import defaultSheets from '../../config/default_sheets';

const BuyerByProductFixDataPage = () => {
  return (
    <FixDataPage
      title="Fix Product Group"
      columns={[
        { name: 'product_sku', type: 'text' },
        { name: 'product_category', type: 'text' },
        { name: 'product_class', type: 'text' },
      ]}
      dataType={'product_group'}
      spreadsheetId={defaultSheets.ProductGroup.defaultSheetUrl}
      spreadsheetRange={defaultSheets.ProductGroup.defaultRange}
      pageId={'fix_product_group'}
    />
  );
};

export default BuyerByProductFixDataPage;
